// extracted by mini-css-extract-plugin
module.exports = {"content_bg":"E5EFF7"};